import moment from 'moment';

export const isDateRange = (rangeStart: string, rangeEnd: string) =>
  moment()
    .utcOffset('+00:00')
    .isBetween(moment.utc(rangeStart), moment.utc(rangeEnd));

export const isPromoAvailableDate = (start: string, end: string) => {
  const today = moment.utc();

  return today.isBetween(moment.utc(start), moment.utc(end), null, '[]');
};
